import { PublicCourseReview } from '@shared/types';

export type Response = {
    reviews: Array<PublicCourseReview>;
    nextPageToken?: string;
};

const GetCourseReviews = (
    educatorSlug: string,
    courseSlug: string,
    pageToken: string | undefined
): Promise<Response> => {
    const queryString = pageToken ? '?' + new URLSearchParams({ pageToken }).toString() : '';

    return fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/reviews/${educatorSlug}/${courseSlug}/list${queryString}`,
        {
            method: 'GET',
            credentials: 'include',
        }
    ).then(async (response) => {
        if (response.ok === true) {
            return response.json();
        }

        const errorResponse = await response.json();
        throw new Error(errorResponse?.description || 'Something went wrong');
    });
};

export default GetCourseReviews;
